import { Component, Input, forwardRef, Output, EventEmitter, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SegmentedControlRadioComponent } from './segmented-control-radio.component';
// import { validateCardNumber } from '@ibe.components/shared/payment/payment-method-card/credit-card-validator';

export class RadioOption {
	label: string;
	value: string;
	disableButton?: boolean;
	tooltip?: string;
	available?: boolean;
	labelKey?: string;

	constructor(label, value, disableButton, tooltip) {
		this.label = label;
		this.value = value;

		if (disableButton) {this.disableButton = disableButton; }
		if (tooltip) {this.tooltip = tooltip; }
	}
}

@Component({
	selector: 'app-segmented-control-radio',
	templateUrl: './segmented-control-radio.indra.component.html',
	styleUrls: ['./segmented-control-radio.indra.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => INDRASegmentedControlRadioComponent),
			multi: true
		}
	]
})
export class INDRASegmentedControlRadioComponent
	extends SegmentedControlRadioComponent
	implements ControlValueAccessor {

	_disable: Array<RadioOption> = [];

	@Output()
	selected = new EventEmitter<any>();

	@Input() _value = '';
	@Input() ariaLabel;
	@Input() options: Array<RadioOption>;
	@Input() classes: string;

	@Input() disableClick: boolean = false;
	@Input() loading: boolean = false;


	@Input()
	set disable(val) {
		this._disable = val;
	}

	get disable() {
		return this._disable;
	}

	@Input()
	set value(val) {
		this._value = val;
		this.propagateChange(this._value);
		this.selected.emit(this._value);
	}

	get value() {
		return this._value;
	}


	propagateChange = (_: any) => { };

	constructor() {
		super();
	}

	/**
	 * @param option {RadioOption} Option item
	 * @returns ngClass Object for @option
	 */
	TAP_optionClasses(option: RadioOption): Object {
		const disabled = this._disable ? this._disable.find(cur => cur.value === option.value) : false;
		return { 
		  'active': option.value === this.value, 
		  'disable': (disabled && disabled.value != this._value) || this.loading 
		};
	  }

	  TAP_select(value) {
		if (this.loading) {
		  return;
		}
		
		if (value == this.value && this.disableClick) {
		  this.value = '';
		  return;
		}
	
		const disabled = this._disable.find(cur => cur.value === value && cur.value != this._value);
		if (disabled) return;
	
		this.value = value;
	  }

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: any): void { }

	writeValue(value: any) {
		this.value = value;
	}
}